import { faUser } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import IconOrSpinner from "../../../../Components/Utils/IconOrSpinner";
import { AtenderAtendimentoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IAssistenciaTecnicaMapeado } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";

interface IBotaoAtenderAtendimentoProps {
    then: () => {};
    ID_CASO: number;
    row?: IAssistenciaTecnicaMapeado;
}

export default function BotaoAtenderAtendimento(
    props: IBotaoAtenderAtendimentoProps
) {
    const {
        execute: execAtenderAtendimento,
        loading: execAtenderAtendimentoLoading,
    } = useAsyncCallback(AtenderAtendimentoController);

    return (
        <OverlayTrigger
            overlay={<Tooltip id="atender-tooltip">Atender</Tooltip>}
        >
            <button
                className="btn btn-icon btn-outline-success"
                onClick={() => {
                    execAtenderAtendimento(props.ID_CASO).then(props.then);
                }}
                disabled={props.row?.AssisTec.FL_SINCRONIZADO === false}
            >
                <IconOrSpinner
                    icon={faUser}
                    loadingSize="sm"
                    loading={execAtenderAtendimentoLoading}
                />
            </button>
        </OverlayTrigger>
    );
}
